/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { getCurrentTexts } from 'redux-app/selectors/localization'
import { text } from 'redux-app/utils/localization'

declare type getStartPathFromProps = (props: any) => string

export const withLocalization = (path: string | getStartPathFromProps) => (WrappedComponent: React.ReactElement) =>
  compose<any, any>(
    connect(
      (state, props) => ({
        texts: getCurrentTexts(state),
        startPath: typeof path === 'function' ? path(props) : path,
      }),
      null,
    ),
    withHandlers({
      t: ({ texts, startPath }) => text({ texts, startPath }),
      getTextPath: ({ startPath }) => path => ({
        startPath,
        path,
      }),
    }),
  )(WrappedComponent)

export type Text = (path: string, params?: any) => any

export type GetTextPath = (path: string) => {
  startPath: string,
  path: string,
}
